var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('color-picker',{attrs:{"value":_vm.value},on:{"change":_vm.headleChangeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }